let languageCode = 'hk';
module.exports = {
	languageCode,
	endonym: '中文',
	displayValue: 'Chinese (Cantonese)',
	raadELLPurpose: '文字是人類獲取知識的地方。你將通過閱讀這些文章來增長你的知識。同時，你也會增加你的詞彙量，提高閱讀能力，每天都享受閱讀！',
	raadELLPurposeAudio: '/assets/dist/audio/set_the_purpose_' + languageCode + '.mp3',
	raadELLMindset:
		'這些文章充滿了大量知識。通過閱讀，你會學到許多新的和重要的東西。你可能不明白很多你讀的東西。那很好！因爲閱讀是你學習新的東西的一種方式。而當你學到一些新東西時，就會更容易學到更多的新東西！也許你已經知道這些文章中的一些知識，這也很好，因爲當你閱讀更多關于你已經知道的內容時，將會增加你的詞彙量，並幫助你學習新的，更廣大的知識領域。最後，通過閱讀這些文章，你會成爲一個很強的讀者，並能夠堅持長期的閱讀。祝閱讀快樂！',
	raadELLMindsetAudio: '',
	raadELLChooseOne: '現在請選擇一篇文章閱讀。',
	raadELLChooseOneAudio: '/assets/dist/audio/aad_instructions_' + languageCode + '.mp3',
	raadELLBOKDirectionsLabel: '說明:',
	raadELLBOKWrite: '請寫下你想要記住的，在文章中學到的2或3樣東西。',
	raadELLBOKWriteAudio: '/assets/dist/audio/bok_instructions_' + languageCode + '.mp3',
	rtl: false
};
